import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);
const columns = [
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'ID',
    data: 'id'
  },
  {
    title: 'Username',
    data: 'USERNAME'
  },
  {
    title: 'Name',
    data: 'NAME'
  },
  {
    title: 'Phone',
    data: 'TEL'
  },
  {
    title: 'Email',
    data: 'EMAIL'
  },
  {
    title: 'Comp. Name',
    data: 'COMPANY_NAME'
  },
  {
    title: 'Comp Phone',
    data: 'COMPANY_NUMBER'
  },
  {
    title: 'Gender',
    data: 'GENDER'
  },
  {
    title: 'Branch',
    data: 'COMPANY_BRANCH'
  },
  {
    title: 'ZIP Code',
    data: 'COMPANY_POSTCODE'
  },
  {
    title: 'Sup. Name',
    data: 'SUP_NAME'
  },
  {
    title: 'Active',
    data: 'IS_ACTIVE'
  },
  {
    title: 'Reg. Date',
    data: 'REG_DATE'
  },
  {
    title: 'Sup. Name',
    data: 'SUP_NAME'
  },
  {
    title: 'Age',
    data: 'AGE_RANGE'
  }
];

function reloadTableData(names) {
  const table = $(`#${id}`).DataTable();
  table.clear();
  table.rows.add(names);
  table.draw();
}

function updateTable(names) {
  const table = $(`#${id}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = names.find((nameData) => {
      return nameData.name === oldNameData.name;
    });
    if (oldNameData.nickname !== newNameData.nickname) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });

  if (dataChanged) {
    table.draw();
  }
}

class Table extends Component {
  componentDidMount() {
    $(`#${id}`).DataTable({
      dom: 'Bfrtip',
      data: this.props.names,
      columns,
      searching: true,
      paging: true,
      ordering: true,
      scrollX: true,
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_user_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_user_excel_${Date.now()}`
        }
      ]
    });
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.names.length !== this.props.names.length) {
      reloadTableData(nextProps.names);
    } else {
      updateTable(nextProps.names);
    }
    return false;
  }

  render() {
    return (
      <div>
        <table ref="main" className='display' id={id} />
      </div>
    );
  }
}
export default Table;
